/* istanbul ignore file */
import { Events, publish } from './utils/Belt';
const UPDATE_CHECK_INTERVAL_MS = 60 * 60 * 1000;
let appRegistration;
// skipWaiting + clientsClaim mean a new worker takes over as soon as it installs,
// so by the time the toolbar icon shows, nothing is installing or waiting any more.
// This remembers that this page is still running the old code.
let updatePending = false;
// Asks the browser to look for a new service worker. Resolves true if one was found,
// or if one has already taken over and the page just needs a reload.
export const checkForUpdate = async () => {
    if (updatePending) {
        return true;
    }
    if (!appRegistration) {
        return false;
    }
    try {
        await appRegistration.update();
    }
    catch (error) {
        console.error(`Update check failed with ${error}`);
    }
    return !!(appRegistration.installing || appRegistration.waiting);
};
if ('serviceWorker' in navigator) {
    // A page that had no controller is a first install, not an update.
    const hadController = !!navigator.serviceWorker.controller;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (hadController) {
            updatePending = true;
            publish(Events.AppUpdateAvailable, '');
        }
    });
    window.addEventListener('load', async () => {
        // microsoft-graph-sw.js used to be registered here too. Both workers share the
        // '/' scope, so each page load swapped one for the other and fired
        // controllerchange, which kept the refresh icon showing. Its only job is
        // caching a disabled host (disable.graph.microsoft.com), so it is not registered.
        // service-worker.js is only generated by production builds
        if (process.env.NODE_ENV === 'production') {
            try {
                appRegistration = await navigator.serviceWorker.register('/service-worker.js');
            }
            catch (error) {
                console.error(`Registration failed with ${error}`);
                return;
            }
            // Installed PWAs are rarely reloaded, so check for new code periodically
            // and whenever the app comes back to the foreground.
            document.addEventListener('visibilitychange', () => {
                if (document.visibilityState === 'visible') {
                    checkForUpdate();
                }
            });
            setInterval(checkForUpdate, UPDATE_CHECK_INTERVAL_MS);
        }
    });
}
